const es_es = {
    LOCALE_KEY: 'es_es',
    LOCALE_NAME: 'Español',
    MISSING_TRANSLATION: 'Traducción faltante',
    MAPPING_ERROR_BANNER_WARNING: '¡Error de mapeo de productos! Por favor, contacte a su administrador de Resort Tools local para resolver. Verifique el estado del mapeo ',
    MAPPING_ERROR_BANNER_HERE: 'aquí',
    PRODUCT_MAPPING_PAGE_INFO: 'Ingrese la información local del producto en el punto de venta para las habilitaciones activas y habilite la integración con el resort',
    VALIDATION_CONFIGURATION_PAGE_INFO: 'Ajuste las fechas de validez por habilitación. El uso fuera de las fechas especificadas no será válido',
    SYSTEM_ADMIN_PAGE_TITLE: 'Administrador del Sistema',
    SAVE_CONFIG_ACTION_ERROR: 'Hubo un error al guardar la configuración.',
    SAVE_CONFIG_SUCCESS_MSG: 'Configuración guardada con éxito',
    GET_CONFIG_FETCH_ERROR: (resort) => `Error inesperado al recuperar la configuración del resort ${resort}. Usando la configuración predeterminada.`,
    FEATURE_TOGGLES: 'Alternar características',
    DIRECT_TO_WINDOW_LABEL: 'Directo a Ventana',
    IS_UAT_LABEL: 'Es UAT',
    IS_UAT_INFO: 'Si la aplicación se está ejecutando en un entorno de prueba de aceptación del usuario.',
    ALL_RESORTS_HOTLIST_LABEL: 'Lista de exclusión para todos los resorts',
    ALL_RESORTS_HOTLIST_INFO: 'Permitir la inclusión y exclusión de huéspedes en la lista negra de todos los resorts.',
    RESORT_SPECIFIC_HOTLIST_LABEL: 'Lista negra específica del resort',
    RESORT_SPECIFIC_HOTLIST_INFO: 'Permitir la inclusión y exclusión de huéspedes solo en este resort.',
    ADD_TO_HOTLIST_LABEL: 'Agregar a la lista negra',
    ADD_TO_HOTLIST_INFO: 'Permitir agregar huéspedes a la lista negra.',
    REMOVE_FROM_HOTLIST_LABEL: 'Eliminar de la lista negra',
    REMOVE_FROM_HOTLIST_INFO: 'Permitir eliminar huéspedes actualmente en la lista negra.',
    REDEMPTION_WARNING_LABEL: 'Advertencia de redención',
    REDEMPTION_WARNING_INFO: 'Mostrar una advertencia al usuario antes de permitirle redimir una habilitación. Útil para usuarios que no pueden realizar una redención correctiva.',
    GROUP_PRINT_LABEL: 'Impresión grupal',
    GROUP_IMPORT_LABEL: 'Importación grupal',
    SHOW_CAMERA_MIRRORING_LABEL: 'Mostrar reflejo de cámara',
    SHOW_CAMERA_MIRRORING_INFO: 'Permitir a los usuarios voltear imágenes de la cámara web horizontalmente.',
    VALIDATION_CONFIGURATION_LABEL: 'Configuración de validación',
    VALIDATION_CONFIGURATION_INFO: 'Permitir a los usuarios ver la configuración de validación del resort.',
    MAPPING_ERROR_BANNER_LABEL: 'Banner de error de mapeo',
    MAPPING_ERROR_BANNER_INFO: 'Permitir a los usuarios ver el banner de error de mapeo de productos',
    WEEKLY_VISITOR_REPORT_LIMIT_LABEL: '/* TODO */Weekly Visitor Report Limit',
    WEEKLY_VISITOR_REPORT_LIMIT_INFO: '/* TODO */ The number reports that can be retrieved',
  
    // User Management
    USER_MANAGEMENT_PAGE_TITLE: 'Gestión de Usuarios',
    USER_MANAGEMENT_PAGE_INFO: 'Los siguientes campos son obligatorios para la creación de usuarios: Nombre, Apellido, Nombre de usuario, Rol, Resort y Contraseña',
    BLOCK_USER_ACTION_ERROR: 'Error al bloquear al usuario.',
    GET_USERS_ACTION_ERROR: 'Error al recuperar usuarios.',
    UNBLOCK_USER_ACTION_ERROR: 'Error al desbloquear al usuario.',
    USER_FIELD_REQUIRED_VALIDATION: 'Requerido',
    USER_FIELD_INVALID_CHARACTERS: (invalidChars: string) => `No debe \nincluir \nletras: \n${invalidChars}`,
    USER_NAME_NOT_AVAILABLE: 'El nombre de usuario \nno está disponible',
    USER_NAME_FORMAT_VALIDATION: 'Debe tener \n4 a 20 letras/números \nincluyendo guion bajo',
    USER_EMAIL_FORMAT_VALIDATION: 'Debe ser una \ndirección de correo \nválida',
    USER_EMAIL_NOT_AVAILABLE: 'El correo \nno está disponible',
    USER_PASSWORD_FORMAT_VALIDATION: 'Debe tener: \n• 8 o más caracteres \n• una letra mayúscula \n• una letra minúscula \n• un número',
    USER_MANAGEMENT_FAILED_USERNAMES_ERROR: (failedUsernames) => `Solicitud de red fallida para: ${failedUsernames}, el nombre de usuario o correo electrónico podría estar en uso.`,
    USER_MANAGEMENT_FILTER_ERROR: (query) => `No hay usuarios que coincidan con ${query}. Si un usuario no aparece en su lista, es posible que exista en otro resort.`,
    USER_MANAGEMENT_USERS_PER_PAGE: 'Usuarios por página',
    USER_MANAGEMENT_NO_USERS: 'Sin usuarios',
    USER_MANAGEMENT_ACCOUNT_DISABLED: 'cuenta deshabilitada',
    USER_MANAGEMENT_FETCH_USERS_FAILED: 'Error al recuperar usuarios. Actualice para intentarlo de nuevo.',
    USER_MANAGEMENT_REMOVE_USER_TITLE: '¿Eliminar Usuario?',
    USER_MANAGEMENT_REMOVE_USER_MSG: (userToDelete) => `¿Está seguro de que desea eliminar a ${userToDelete}?`,
    USER_MANAGEMENT_REMOVE_BUTTON: 'Eliminar',
    USER_MANAGEMENT_CANCEL_REMOVE_BUTTON: 'Cancelar',
    USER_MANAGEMENT_TABLE_FIRST_NAME: 'Nombre',
    USER_MANAGEMENT_TABLE_LAST_NAME: 'Apellido',
    USER_MANAGEMENT_TABLE_USERNAME: 'Nombre de usuario',
    USER_MANAGEMENT_TABLE_EMAIL: 'Correo electrónico',
    USER_MANAGEMENT_TABLE_ROLE: 'Rol',
    USER_MANAGEMENT_TABLE_RESORTS: 'Resorts',
    USER_MANAGEMENT_TABLE_PASSWORD: 'Contraseña',
    USER_MANAGEMENT_TABLE_LAST_LOGIN: 'Último inicio de sesión',
    USER_MANAGEMENT_TABLE_NO_USERS: 'Sin usuarios.',
    USER_ROW_SELECT_PLACEHOLDER: 'Seleccione...',
    USER_ROW_CREATE_USER: ' Crear Usuario',
    USER_ROW_SAVE_CHANGES: 'Guardar cambios',
    USER_ROW_DISCARD_CHANGES: 'Descartar cambios',
    USER_ROW_UPDATE_USER: 'Actualizar Usuario',
    USER_ROW_DELETE_USER: 'Eliminar Usuario',
    USER_ROW_FIRST_NAME: 'Nombre',
    USER_ROW_LAST_NAME: 'Apellido',
    USER_ROW_USERNAME: 'Nombre de usuario',
    USER_ROW_SUGGESTED_USERNAME: (suggestedUsername) => `Nombre de usuario sugerido ${suggestedUsername}`,
    USER_ROW_EMAIL: 'Correo electrónico',
    USER_ROW_USER_ROLE: 'Rol de usuario',
    USER_ROW_NO_ROLES: 'Sin roles',
    USER_ROW_PASSWORD: 'Contraseña',
    USER_ROW_UPDATE_PASSWORD: 'Actualizar Contraseña',
    USER_SEARCH_BOX_BLACKLIST_WARNING: 'Advertencia: Término de búsqueda en lista negra',
    USER_SEARCH_BOX_TITLE: 'Buscar un Usuario de Resort Tools',
    USER_SEARCH_BOX_SEARCH: 'Buscar',
    USER_SEARCH_BOX_PLACEHOLDER: 'Buscar un Usuario',
    USER_EDIT_MENU_ENABLE_USER_TITLE: 'Habilitar usuario',
    USER_EDIT_MENU_DISABLE_USER_TITLE: 'Deshabilitar usuario',
    USER_EDIT_MENU_ENABLE_USER: 'Habilitar',
    USER_EDIT_MENU_DISABLE_USER: 'Deshabilitar',
    USER_EDIT_MENU_DELETE_USER_TITLE: 'Eliminar',
    USER_EDIT_MENU_RESET_PASSWORD: 'Restablecer Contraseña',
    USER_EDIT_MENU_MORE_OPTIONS: 'Más Opciones',
  
    // FAQ Pages
    FAQ_PAGE_TITLE: 'Preguntas Frecuentes',
    FAQ_PAGE_FETCH_FAILED: 'Error al recuperar las preguntas frecuentes. Actualice e inténtelo de nuevo.',
    FAQ_PAGE_NO_FAQ: 'No hay preguntas frecuentes en este momento. Vuelva más tarde para más información.',
    FAQ_PAGE_LOADING_FAQ: 'Cargando preguntas frecuentes',
    MAKE_FAQ_PAGE_NO_FAQ: 'No hay preguntas frecuentes. Intente crear una nueva o cargar un archivo JSON existente arriba.',
    MAKE_FAQ_PAGE_MAKE_FAQ_JSON: 'Crear JSON de preguntas frecuentes',
    MAKE_FAQ_PAGE_NEW_FAQ: 'Nueva pregunta frecuente',
    MAKE_FAQ_PAGE_SAVE_FAQ: 'Guardar',
  
    // Help and Training Pages
    HELP_TRAINING_PAGE_TITLE: 'Ayuda y Capacitación',
    HELP_TRAINING_LOADING: 'Cargando documentos',
    HELP_TRAINING_FETCH_FAILED: 'Error al recuperar los documentos de capacitación. Actualice e inténtelo de nuevo.',
    HELP_TRAINING_NO_DOCS: 'No hay documentos de capacitación en este momento. Vuelva más tarde para más información.',
    HELP_TRAINING_VIEWER_FAILED: 'Error al mostrar este documento. Actualice e inténtelo de nuevo.',
    HELP_TRAINING_BACK: 'Volver a los documentos',
    HELP_TRAINING_UPLOAD_BUTTON: 'Subir documento',
    HELP_TRAINING_REPLACE_BUTTON: 'Reemplazar',
    HELP_TRAINING_DELETE_BUTTON: 'Eliminar',
    HELP_TRAINING_FORM_TITLE_UPLOAD: 'Subir documento de capacitación',
    HELP_TRAINING_FORM_TITLE_REPLACE: 'Reemplazar documento de capacitación',
    HELP_TRAINING_FORM_FILE_LABEL: 'Archivo del documento (.docx)',
    HELP_TRAINING_FORM_DOC_TITLE_LABEL: 'Título',
    HELP_TRAINING_FORM_SORT_ORDER_LABEL: 'Orden',
    HELP_TRAINING_FORM_SUBMIT: 'Guardar',
    HELP_TRAINING_FORM_CANCEL: 'Cancelar',
    HELP_TRAINING_DELETE_CONFIRM_TITLE: '¿Eliminar documento?',
    HELP_TRAINING_DELETE_CONFIRM_MSG: (title: string) => `¿Está seguro de que desea eliminar "${title}"? Esta acción no se puede deshacer.`,
    HELP_TRAINING_WRITE_FAILED: 'La acción falló. Inténtelo de nuevo.',

    // Release Notes Pages
    RELEASE_NOTES_PAGE_TITLE: 'Notas de Lanzamiento',
    RELEASE_NOTES_PAGE_LOADING: 'Cargando notas de lanzamiento',
    RELEASE_NOTES_PAGE_NO_NOTES: 'No hay notas de lanzamiento en este momento. Vuelva más tarde para más información.',
    RELEASE_NOTES_PAGE_FETCH_FAILED: 'Error al recuperar las notas de lanzamiento. Actualice e inténtelo de nuevo.',
    MAKE_RELEASE_NOTES_PAGE_JSON: 'Crear JSON de notas de lanzamiento',
    MAKE_RELEASE_NOTES_NO_NOTES: 'Sin notas de lanzamiento. Intente crear una nueva o cargar un archivo JSON existente arriba.',
    MAKE_RELEASE_NOTES_NEW_NOTE: 'Nueva nota',
    MAKE_RELEASE_NOTES_SUBMIT_NOTES: 'Enviar notas de lanzamiento',
  
    // App Doc Form
    APP_DOC_FAQ_NEEDS_TITLE: '¡Este ítem de FAQ necesita un título!',
    APP_DOC_FAQ_NEEDS_BODY: '¡Este ítem de FAQ necesita un cuerpo!',
    APP_DOC_FAQ_ITEM_HEADER: 'Ítem de FAQ',
    APP_DOC_FORM_LABEL_TITLE: 'Título',
    APP_DOC_FORM_LABEL_ROLES: 'Mostrar para Roles',
    APP_DOC_FORM_SUBLABEL_ROLES: '(Pegue un valor nuevo)',
    APP_DOC_FORM_LABEL_DTW_RESORTS: 'Para Resorts DTW',
    APP_DOC_FORM_SAVE: 'Guardar',
    APP_DOC_FORM_CANCEL: 'Cancelar',
  
    // Auth
    GET_CONFIG_ACTION_ERROR : 'Error inesperado al recuperar la configuración de la app.',
    GET_USER_INFO_ACTION_ERROR: 'Error al recuperar usuario.',
    AUTH0_LOGIN_ERROR: 'Su cuenta ha sido deshabilitada. Por favor, contacte a su administrador.',
    AUTH0_LOGIN: 'Iniciar sesión',
    AUTH0_LOGIN_TITLE: 'Iniciar sesión en EPIC Resort',
    LOGIN_FORM_APP_CONFIG_FETCH_FAILED: 'Error al recuperar la configuración de la app',
    LOGIN_FORM_ALL_FIELDS_REQUIRED: 'Todos los campos son obligatorios',
    LOGIN_FORM_ENTER_USERNAME: 'Ingrese su nombre de usuario',
    LOGIN_FORM_USERNAME: 'Nombre de usuario',
    LOGIN_FORM_ENTER_PASSWORD: 'Ingrese su contraseña',
    LOGIN_FORM_PASSWORD: 'Contraseña',
    LOGIN_FORM_LOGIN_TITLE: 'Iniciar sesión en EPIC Resort',
    LOGIN_FORM_LOGIN: 'Iniciar sesión',
  
    // Branding
    RESORT_TOOLS_LOGO_HEADER: 'Herramientas del Resort',
  
    // copyToClipboard
    COPIED_TO_CLIPBOARD: '¡Copiado al portapapeles!',
    COPY_TO_CLIPBOARD: 'Copiar al portapapeles',
  
    // core
    GET_APPLIANCE_VERSION_ACTION_ERROR: 'Error inesperado al recuperar la versión del dispositivo.',
  
    // entitlementTypes
    GET_ENTITLEMENT_TYPES_ACTION_ERROR: 'Error al cargar tipos de habilitación. Inténtelo más tarde.',
  
    // entitlementTypesMetadata
    GET_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR: 'Error al recuperar los metadatos de los tipos de habilitación.',
    UPDATE_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR: 'Error inesperado al actualizar los metadatos de los tipos de habilitación.',
  
    // forms
    AUTO_FORM_SAVE: 'Guardar',
    AUTO_FORM_RESET: 'Reiniciar',
    DROPDOWN_PLEASE_SELECT: 'Por favor seleccione...',
    CHARACTER_COUNT_CHARACTERS: 'Caracteres:',
    PASSWORD_FIELD_SHOW_PASSWORD: 'Mostrar Contraseña',
    PASSWORD_FIELD_HIDE_PASSWORD: 'Ocultar Contraseña',
    TOGGLE_SWITCH_ON: 'ENCENDIDO',
    TOGGLE_SWITCH_OFF: 'APAGADO',
  
    // Landing page
    RESET_USER_PASSWORD_MISMATCH_ERROR: 'Las contraseñas no coinciden, por favor vuelva a ingresar su nueva contraseña',
    RESET_USER_PASSWORD_RESET_COMPLETE: '¡Restablecimiento de Contraseña Completo!',
    RESET_USER_PASSWORD_CANCEL: 'CANCELAR',
    RESET_USER_PASSWORD_OK: 'OK',
    RESET_USER_PASSWORD_PASSWORD_RESET: 'Restablecimiento de Contraseña',
    RESET_USER_PASSWORD_RESET_INSTRUCTIONS: 'Por favor, ingrese su nueva contraseña dos veces',
    RESET_USER_PASSWORD_PASSWORD_PLACEHOLDER: 'Contraseña',
    RESET_USER_PASSWORD_CONNECTION_ERROR: 'Error de Conexión. Inténtelo más tarde',
    RESET_USER_PASSWORD_SAVE: 'GUARDAR',
  
    // layout
    FLOATING_MENU_CLOSE: 'Cerrar menú',
    FLOATING_MENU_OPEN: 'Abrir menú',
    MODAL_TITLE_HEADER_CLOSE: 'Cerrar',
  
    // pageHeader
    HEADER_MENU_SYSTEM_ADMIN: 'Administración del Sistema',
    HEADER_MENU_VALIDATION_CONFIG: 'Configuración de Validación',
    HEADER_MENU_USER_MANAGEMENT: 'Gestión de Usuarios',
    HEADER_MENU_HELP_AND_TRAINING: 'Ayuda y Capacitación',
    HEADER_MENU_FAQ: 'Preguntas Frecuentes',
    HEADER_MENU_REPORTS: 'Missing Translation',
    HEADER_MENU_RELEASE_NOTES: 'Notas de Lanzamiento',
    HEADER_MENU_SIGNOUT: 'Cerrar sesión',
    HEADER_MENU_PRODUCT_MAPPING: 'Mapeo de Productos',
    PAGE_HEADER_BACK_TO_LANDING: 'Volver a la Página Principal',
    PAGE_HEADER_SIGNED_IN_AS: (currentUser) => `Conectado como ${currentUser}`,
    PAGE_HEADER_SIGNED_IN_AS_WITH_ROLE: (currentUser, userRole) => `Conectado como ${currentUser} ${userRole}`,
    RESORT_SELECT_MENU_LOAD_CONFIG_ERROR: (resortName) => `Error inesperado al recuperar la configuración del resort ${resortName}. Usando configuración predeterminada.`,
  
    // resortDetails
    GET_RESORT_DETAILS_ACTION_ERROR: 'No se encontraron resorts en la respuesta',
  
    // validationConfigurationTool
    VALIDATION_CONFIG_INVALID_EFFECTIVE_DATE: 'Se requiere una fecha de inicio válida.',
    VALIDATION_CONFIG_INVALID_EXPIRATION_DATE: 'Se requiere una fecha de expiración válida.',
    VALIDATION_CONFIG_EXPIRES_BEFORE_EFFECTIVE_DATE: 'El producto debe expirar en o después de la fecha de inicio.',
    VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'La fecha de inicio debe estar dentro de un año desde el inicio de la temporada',
    VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'La fecha de inicio debe ser anterior a la fecha de finalización de la temporada',
    VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'La fecha de expiración debe estar dentro de un año desde el final de la temporada',
    VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'La fecha de expiración debe ser posterior a la fecha de inicio de la temporada',
    VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_SEASON_START: 'Advertencia: La fecha de inicio está fuera de la fecha de inicio de la temporada',
    VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_SEASON_END: 'Advertencia: La fecha de expiración está fuera de la fecha de finalización de la temporada',
    VALIDATION_CONFIG_FAILED_NETWORK_REQUEST: 'Error en la solicitud de red al actualizar la configuración de validación del resort. Inténtelo más tarde.',
    VALIDATION_CONFIG_UNABLE_TO_SAVE: '¡No se pueden guardar los productos! Verifique todas las fechas en busca de errores.',
    VALIDATION_CONFIG_ERROR_OVERLAPPING_DATES: 'Las fechas del producto no pueden superponerse entre la Temporada de Cumplimiento',
    VALIDATION_CONFIG_CANCEL_EDITS: 'Cancelar Ediciones',
    VALIDATION_CONFIG_EDIT_PRODUCTS: 'Editar Productos',
    VALIDATION_CONFIG_SAVE_PRODUCTS: 'Guardar Productos',
    VALIDATION_CONFIG_SAVE: 'Guardar',
    VALIDATION_CONFIG_CANCEL: 'Cancelar',
    VALIDATION_CONFIG_SAVE_PRODUCTS_CONFIRMATION: '¿Está seguro de que desea guardar los productos?',
    VALIDATION_CONFIG_DATA_CHANGE_WARNING: 'Cualquier cambio en el rango de fechas podría afectar las validaciones en vivo',
    VALIDATION_CONFIG_START_DATE_PLACEHOLDER: 'Fecha de Inicio',
    VALIDATION_CONFIG_EXPIRE_DATE_PLACEHOLDER: 'Fecha de Expiración',
    VALIDATION_CONFIG_NO_DATA: 'No hay configuraciones de validación para este resort.',
    VALIDATION_CONFIG_TABLE_PRODUCT: 'Producto',
    VALIDATION_CONFIG_TABLE_SEASON: 'Temporada',
    VALIDATION_CONFIG_TABLE_FULFILLMENT_SEASON: 'Temporada de Cumplimiento',
    VALIDATION_CONFIG_TABLE_MAX_DAYS: 'Días Máximos',
    VALIDATION_CONFIG_TABLE_START_DATE: 'Fecha de Inicio',
    VALIDATION_CONFIG_TABLE_EXPIRE_DATE: 'Fecha de Expiración',
    VALIDATION_CONFIG_TITLE: 'Configuración de Validación del Resort',
    VALIDATION_CONFIG_ROW_UNLIMITED: 'Ilimitado',
    VALIDATION_CONFIG_ROW_MAX_DAYS: (maxDays) => `${maxDays} Días`,
    VALIDATION_CONFIG_ROW_START_DATE: 'Fecha de Inicio',
    VALIDATION_CONFIG_ROW_EXPIRE_DATE: 'Fecha de Expiración',
  
    // version
    CENTRAL_APPLIANCE_VERSION: 'Versión del Aparato Central',
    RESORT_TOOLS_VERSION: 'Versión de Resort Tools',
  
    // webcam
    PHOTO_BOOTH_CAM: 'Cámara',
    PHOTO_BOOTH_SELECT_WEBCAM: 'Seleccione la cámara web para tomar fotos',
    PHOTO_BOOTH_SELECT_WEBCAM_PLACEHOLDER: 'Seleccione una Cámara',
    PHOTO_BOOTH_FLIP_CAMERA_FRAME_HORIZONTALLY: 'Invertir el Marco de la Cámara Horizontalmente',
    PHOTO_BOOTH_FLIP_CAMERA_IMAGE_HORIZONTALLY: 'Voltear la imagen de la cámara horizontalmente.',
    PHOTO_BOOTH_CANCEL_RETAKE: 'Cancelar la nueva toma y usar la foto anterior',
    PHOTO_BOOTH_TAKE_NEW_PICTURE: 'Tomar una nueva foto',
    PHOTO_BOOTH_TAKE_PICTURE: 'Tomar Foto',
    PHOTO_BOOTH_SAVE_PICTURE: 'Guardar Esta Foto',
    PHOTO_BOOTH_SAVE: 'Guardar',
    PHOTO_BOOTH_RETAKE: 'Volver a tomar',
    PHOTO_BOOTH_CAPTURE: 'Capturar',
    PHOTO_BOOTH_CANCEL: 'Cancelar',
    PHOTO_BOOTH_REVERSE_CAMERA: 'Invertir Cámara',
    WEBCAM_BROWSER_ERROR: 'Este navegador no admite la captura de cámara web nativa.',
    WEBCAM_STREAMING_ERROR: 'La cámara no está transmitiendo.',
  
    // resortMappingTool
    GET_RESORT_MAPPING_ACTION_ERROR: 'Error inesperado al cargar el historial del resort.',
    GET_RESORT_MAPPING_HAS_ERROR_ACTION_ERROR: 'Error inesperado al cargar el estado de error de mapeo de productos del resort.',
    UPDATE_MAPPING_ERRORS_ACTION_ERROR: 'Error inesperado al cargar el mapeo de productos.',
    PRODUCT_MAPPING_UPLOAD_TITLE: 'Carga Masiva de Mapas de Productos',
    PRODUCT_MAPPING_UPLOAD_CANCEL: 'Cancelar',
    PRODUCT_MAPPING_UPLOAD_UPLOAD: 'Subir',
    PRODUCT_MAPPING_UPLOAD_DOWNLOAD: 'Descargar',
    PRODUCT_MAPPING_UPLOAD_ONE: 'Descargar Mapas para obtener todos los productos disponibles',
    PRODUCT_MAPPING_UPLOAD_ONE_WARNING: 'Solo se pueden mapear productos activos',
    PRODUCT_MAPPING_UPLOAD_TWO: 'Utilice el archivo descargado para agregar detalles relevantes a las columnas específicas del resort',
    PRODUCT_MAPPING_UPLOAD_TWO_WARNING: 'Mantenga todos los encabezados de columna existentes, son esenciales para el éxito de la carga',
    PRODUCT_MAPPING_UPLOAD_THREE: 'Arrastre y suelte o busque su archivo editado para adjuntarlo al cargador',
    PRODUCT_MAPPING_UPLOAD_FOUR: 'Haga clic en Subir Mapas para subir el archivo seleccionado',
    PRODUCT_MAPPING_UPLOAD_CHOOSE_FILE: 'Seleccione un archivo CSV para cargar',
    PRODUCT_MAPPING_UPLOAD_INSTRUCTION: 'Arrastre el archivo .csv aquí o haga clic en Elegir Archivo',
    PRODUCT_MAPPING_UPLOAD_SUCCESS: 'CSV subido con éxito!',
    PRODUCT_MAPPING_UPLOAD_WRONG_HEADERS: 'Los encabezados de las columnas editables son incorrectos o no están en el orden correcto',
    PRODUCT_MAPPING_UPLOAD_NO_MATCH: "No se encontraron coincidencias de id de habilitación",
    PRODUCT_MAPPING_UPLOAD_NO_CHANGES: 'No se detectaron cambios',
    PRODUCT_MAPPING_UPLOAD_NO_FILE: 'No se seleccionó ningún archivo',
    PRODUCT_MAPPING_UPLOAD_WRONG_FILE_TYPE: 'El archivo no es un .csv, por favor suba solo archivos .csv',
    RESORT_MAPPING_COLUMN_PRODUCT: 'Producto',
    RESORT_MAPPING_COLUMN_SEASON: 'Temporada',
    RESORT_MAPPING_COLUMN_AGE: 'Edad',
    RESORT_MAPPING_COLUMN_FULFILLMENT_SEASON: 'Temporada de Cumplimiento',
    RESORT_MAPPING_COLUMN_PRODUCT_HEADER_CODE: 'Código de Encabezado del Producto',
    RESORT_MAPPING_COLUMN_ACCESS_RULE: 'Regla de Acceso',
    RESORT_MAPPING_COLUMN_MEDIA_PRODUCT_HEADER_CODE: 'Código de Encabezado del Producto de Medios',
    RESORT_MAPPING_COLUMN_DEPARTMENT: 'Departamento',
    RESORT_MAPPING_COLUMN_CATEGORY: 'Categoría',
    RESORT_MAPPING_COLUMN_ITEM: 'Ítem',
    RESORT_MAPPING_COLUMN_PRODUCT_TYPE: 'Tipo de Producto',
    RESORT_MAPPING_COLUMN_WTP_RELOAD: 'Recarga WTP',
    RESORT_MAPPING_COLUMN_MAPPING_STATUS: 'Estado del Mapeo',
    PRODUCT_MAPPING_PAGE_LOAD_ERROR: 'Error inesperado al cargar los mapas del resort.',
    PRODUCT_MAPPING_PAGE_EDIT_PRODUCTS: 'Editar Productos',
    PRODUCT_MAPPING_PAGE_SAVE_PRODUCTS: 'Guardar Productos',
    PRODUCT_MAPPING_PAGE_SYNC: 'Sincronizar',
    PRODUCT_MAPPING_PAGE_DOWNLOAD: 'Descargar',
    PRODUCT_MAPPING_PAGE_BULK_UPLOAD: 'Carga Masiva',
    PRODUCT_MAPPING_PAGE_TITLE: 'Mapeo de Productos del Resort',
    PRODUCT_MAPPING_PAGE_NOT_IMPLEMENTED: 'Función no implementada.',
  
    // Guest Media
    ASSOC_RFID_REPRINT_MESSAGE_NO_ID: 'El huésped no tiene un ID de medio. Imprima un pase primero.',
    ASSOC_RFID_REPRINT_MESSAGE_HAS_ID: (currentRfid) => `El huésped ya tiene un pase vinculado. Reimprimir desactivará el pase actual y vinculará uno nuevo.\n\nCódigo RFID actual: ${currentRfid}`,
    ASSOC_RFID_MODAL_HEADER: 'Vincular Tarjeta RFID',
    GUEST_LINK_RFID_LABEL: 'Vincular RFID',
    GUEST_LINK_RFID_INPUT_TITLE: 'Ingrese el número de RFID',
    GUEST_LINK_RFID_INPUT_PLACEHOLDER: 'Número RFID',
    RFID_LENGTH_ERROR: 'El ID de RFID debe ser un número de 20 dígitos. No se aceptan letras ni símbolos.',
    RFID_DUPLICATE_ERROR: (firstName, lastName, chipId) => `Este código RFID ya está vinculado a ${firstName} ${lastName}.\nRFID: ${chipId}`,
    RFID_FORM_LABEL: 'Huésped:',
    RFID_FORM_TITLE: (guestName) => `Vincular RFID para ${guestName}`,
    RFID_FORM_RETURN: 'Regresar a la Tarjeta del Huésped',
    RFID_FORM_CANCEL_RFID_LINKING: 'Cancelar vinculación de RFID',
    RFID_FORM_SUBMIT_RFID: 'Enviar RFID',
    RFID_FORM_OKAY: 'Aceptar',
    RFID_FORM_CANCEL: 'Cancelar',
    RFID_FORM_SUBMIT: 'Enviar',
    MEDIA_HISTORY_MODAL_TITLE: 'Historial de Tarjetas de Medios',
    MEDIA_HISTORY_MODAL_ACTIVE: 'Activo',
    MEDIA_HISTORY_MODAL_INACTIVE: 'Inactivo',
    MEDIA_STATUS_SELECTOR_DISABLED: 'Desactivado',
    MEDIA_HISTORY_MODAL_COLUMN_ID: 'ID de la Tarjeta de Medios',
    MEDIA_HISTORY_MODAL_COLUMN_RFID: 'RFID',
    MEDIA_HISTORY_MODAL_COLUMN_AGENT: 'Agente',
    MEDIA_HISTORY_MODAL_COLUMN_PRINT_DATE: 'Fecha de Impresión',
    MEDIA_HISTORY_MODAL_COLUMN_PRINT_STATUS: 'Estado de la Impresión',
    MEDIA_HISTORY_MODAL_COLUMN_RESORT: 'Resort',
    MEDIA_HISTORY_MODAL_COLUMN_STATUS: 'Estado',
    MEDIA_HISTORY_MODAL_MESSAGE: 'Una vez que una tarjeta de medios está desactivada, no puede ser reactivada a través de Resort Tools',
    MEDIA_HISTORY_MODAL_CONFIRMATION: (mediaId) => `¿Está seguro de que desea desactivar la tarjeta de medios ${mediaId}?`,
    MEDIA_HISTORY_MODAL_NO_DATA: 'No hay historial de tarjetas de medios.',
    MEDIA_HISTORY_MODAL_FAILED_FETCH: (guestName) => `Error al recuperar el historial de medios de ${guestName}. Inténtelo de nuevo.`,
    MEDIA_HISTORY_MODAL_CANCEL: 'Cancelar',
    MEDIA_HISTORY_MODAL_CONFIRM: 'Confirmar',
  
    GROUP_PRINT_MODAL_LABEL: 'Todos los elegibles',
    GROUP_PRINT_MODAL_GUEST_COUNT: (guestCount) => `Huéspedes para imprimir: ${guestCount}`,
    GROUP_PRINT_MODAL_WARNING: `Una vez que inicie esta solicitud de impresión, los pases existentes de los huéspedes dejarán de funcionar.`,
    GROUP_PRINT_MODAL_CANCEL: 'Cancelar',
    GROUP_PRINT_MODAL_PRINT: 'Imprimir',
    GROUP_PRINT_MODAL_GENERATE_PDF: 'Generando PDF',
    GROUP_PRINT_MODAL_LINK_RFID: 'Vincular RFID:',
    GROUP_PRINT_MODAL_OKAY: 'Aceptar',
    GROUP_PRINT_MODAL_GROUP_LINK: 'Vinculación grupal de RFID',
    GROUP_PRINT_MODAL_GROUP_PRINT: 'Imprimir pase grupal',
    GROUP_PRINT_MODAL_FOUND_ERRORS: (errorCount) => `Se encontraron ${errorCount} errores`,
    PASS_PRINT_MODAL_NO_ACTIVE_MEDIA: 'No se puede iniciar la reimpresión, el huésped no tiene un medio activo.',
    PASS_PRINT_MODAL_GENERATE_PDF: 'Generando PDF',
    PASS_PRINT_MODAL_CANCEL_TITLE: 'Cancelar impresión de pase para el huésped',
    PASS_PRINT_MODAL_CANCEL: 'Cancelar',
    PASS_PRINT_MODAL_HEADING: 'Imprimir Pase',
    PASS_PRINT_MODAL_OK_BTN_CLOSE: 'Cerrar',
    PASS_PRINT_MODAL_OK_BTN_PRINT: 'Imprimir',
    REISSUE_MEDIA_ACTION_UNKNOWN_ERROR: 'Error desconocido',
    NEED_PHOTO_AND_WAIVER: 'Para imprimir un pase, asegúrese de que este huésped firme una exención y capture su foto.',
    NEED_PHOTO: 'Para imprimir un pase, capture la foto de este huésped.',
    NEED_WAIVER: 'Para imprimir un pase, asegúrese de que este huésped firme una exención.',
    PRINT_CONFIRMATION_1: (guestName) => `¿Está seguro de que desea imprimir un nuevo pase para ${guestName}?`,
    PRINT_CONFIRMATION_2: 'El pase existente del huésped dejará de funcionar una vez que inicie el proceso de impresión.',
    API_ERROR: 'Error al generar un PDF e iniciar la impresión. Actualice e inténtelo de nuevo.',
    PRINT_FAILURE: 'No se pudo abrir el PDF. Verifique su bloqueador de ventanas emergentes.',
  
    // Guest redemption
    DTW_ENTITLEMENT_MODAL_MESSAGE: 'Una vez que se redime un día, no se puede agregar de nuevo al pase.',
    DTW_ENTITLEMENT_MODAL_CONFIRMATION: '¿Está seguro de que desea redimir ',
    DTW_ENTITLEMENT_MODAL_CONFIRMATION_NAME: (guestName) => `de ${guestName} `,
    DTW_ENTITLEMENT_MODAL_CANCEL: 'Cancelar',
    DTW_ENTITLEMENT_MODAL_CONFIRM: 'Confirmar',
    DTW_ENTITLEMENT_MODAL_HEADING: 'Redimir Pase Diario',
    DTW_ENTITLEMENT_MODAL_GUEST_LABEL: "Huésped:",
    DTW_ENTITLEMENT_MODAL_PASS_LABEL: "Pase:",
    DTW_ENTITLEMENT_MODAL_NO_ITEMS: "No hay Pases Disponibles",
    DTW_ENTITLEMENT_MODAL_NO_DAYS: "No hay Días Disponibles",
    DTW_ENTITLEMENT_MODAL_REDEMPTION_COMPLETE: 'Redención Completa',
    DTW_ENTITLEMENT_MODAL_FAILED_FETCH: (guestName) => `Error al recuperar las habilitaciones de ${guestName}. Inténtelo de nuevo.`,
    DTW_ENTITLEMENT_MODAL_FAILED_REDEMPTION: (guestName) => `Error al redimir los días Direct to Window de ${guestName}. Inténtelo de nuevo.`,
    DTW_ENTITLEMENT_MODAL_PLURALIZED_DAY: (quantity) => `día${+quantity !== 1 ? 's' : ''}`,
  
    FNF_TABLE_CONFIRMATION: '¿Está seguro de que desea redimir ',
    FNF_TABLE_CONFIRMATION_NAME: (days, possessiveGuestName) => ` Amigos y Familia ${days} de ${possessiveGuestName} `,
    FNF_TABLE_ENTITLEMENT_NAME: 'Nombre de la Habilitación',
    FNF_TABLE_DAYS_AVAILABLE: 'Días Disponibles',
    FNF_TABLE_DAYS_USED: 'Días Usados',
    FNF_TABLE_REDEEM: 'Redimir',
    FNF_TABLE_BLACKED_OUT: 'Bloqueado',
    FNF_TABLE_ALL_USED: 'Todo Usado',
    FNF_TABLE_NO_ENTITLEMENTS: 'No se encontraron habilitaciones.',
    FNF_TABLE_PLURALIZED_DAY: (redeemQuantity) => `día${+redeemQuantity !== 1 ? 's' : ''}`,
    FNF_MODAL_REDEMPTION_COMPLETE: 'Redención Completa',
    FNF_HISTORY_COLUMN_FROM_GUEST: 'De Huésped',
    FNF_HISTORY_COLUMN_TO_GUEST: 'A Huésped',
    FNF_HISTORY_COLUMN_SHARE_DATE: 'Fecha de Compartir',
    FNF_HISTORY_COLUMN_CLAIM_DATE: 'Fecha de Reclamo',
    FNF_HISTORY_COLUMN_REVOKE_DATE: 'Fecha de Revocación',
    FNF_HISTORY_COLUMN_STATUS: 'Estado',
    FNF_HISTORY_COLUMN_DATE: 'Fecha',
    FNF_HISTORY_COLUMN_RESORT: 'Resort',
    FNF_HISTORY_COLUMN_REF_ID: 'ID de Ref.',
    FNF_HISTORY_SHARE: 'Historial de Compartir',
    FNF_HISTORY_REDEEM: 'Historial de Redención',
    FNF_HISTORY_GUEST_LABEL: 'Huésped:',
    FNF_HISTORY_NO_HISTORY: 'Sin historial',
    FNF_HISTORY_COPY_MGID: 'MGID Copiado',
    FNF_HISTORY_FAILED_FETCH: (guestName) => `Error al recuperar el historial de compartir de ${guestName}. Inténtelo de nuevo`,
    FNF_MODAL_REDEEM_TAB: 'F&F Redimir',
    FNF_MODAL_HISTORY_TAB: 'Historial',
    FNF_MODAL_FAILED_FETCH: (guestName) => `Error al recuperar las habilitaciones de ${guestName}. Inténtelo de nuevo.`,
    FNF_MODAL_FAILED_REDEMPTION: (guestName) => `Error al redimir los pases de Amigos y Familia de ${guestName}. Inténtelo de nuevo.`,
  
    VIEW_DAYS_VIEW_DAYS_TAB_HEADER: 'Ver Días',
    VIEW_DAYS_VIEW_HISTORICAL_TAB_HEADER: 'Ver Historial',
    VIEW_DAYS_FAILED_FETCH_ERROR: 'Error al recuperar los tipos de redención.',
    VIEW_DAYS_HISTORY_ERROR: 'Error inesperado al cargar el historial del resort.',
    VIEW_DAYS_RESORT_SELECTOR_PASS_LABEL: 'Pase: ',
    VIEW_DAYS_RESORT_SELECTOR_PASS_TITLE: 'Pase',
    VIEW_DAYS_RESORT_SELECTOR_RESORT_LABEL: 'Resort: ',
    VIEW_DAYS_RESORT_SELECTOR_RESORT_TITLE: 'Resorts',
    VIEW_DAYS_TAB_NOT_APPLICABLE: 'N/A',
    VIEW_DAYS_TAB_COLUMN_REDEMPTION_ID: 'ID de Redención',
    VIEW_DAYS_TAB_COLUMN_TYPE: 'Tipo',
    VIEW_DAYS_TAB_COLUMN_DATE: 'Fecha',
    VIEW_DAYS_TAB_COLUMN_RESORT: 'Resort',
    VIEW_DAYS_TAB_COLUMN_MODIFIED_BY: 'Modificado Por',
    VIEW_DAYS_TAB_COLUMN_DAYS_USED: 'Días Usados',
    VIEW_DAYS_TAB_COLUMN_NOTES: 'Notas',
    VIEW_DAYS_TAB_MODAL_HEADER: 'Corregir Redención del Día',
    VIEW_DAYS_CORRECTION_BUTTON_TITLE: 'Corregir Redención',
    VIEW_DAYS_STATS_TOTAL_DAYS: 'Total de Días',
    VIEW_DAYS_STATS_RESORTS: 'Resorts',
    VIEW_DAYS_STATS_MOST_VISITED: (name) => `Más visitado: ${name}`,
    VIEW_DAYS_GUEST_LABEL: 'Huésped:',
    VIEW_DAYS_FAILED_FETCH: (guestName) => `Error al recuperar los resorts de ${guestName} para este pase.`,
    VIEW_DAYS_FAILED_HISTORY: (guestName) => `Error al recuperar el historial de ${guestName} en un resort. Inténtelo de nuevo.`,
    VIEW_DAYS_NO_DATA: 'No hay historial para este huésped en este resort.',
    VIEW_DAYS_NO_DATA_FOUND_ERROR: 'No se encontraron datos',
    VIEW_DAYS_UNLIMITED: 'Ilimitado',
  
    VIEW_HISTORICAL_TAB_LOADING_DATA: 'Cargando Datos Históricos',
    VIEW_HISTORICAL_TAB_TOTAL_DAYS: (totalDays) => `Total de Días: ${totalDays}`,
    DAY_CORRECTION_REDEMPTION_LABEL: 'ID de Redención Original:',
    DAY_CORRECTION_REDEMPTION_TITLE: 'ID de Redención Original',
    DAY_CORRECTION_REDEMPTION_BUTTON_TITLE: 'Copiar ID de Redención al Portapapeles',
    DAY_CORRECTION_QUANTITY_LABEL: 'Cantidad de Corrección:',
    DAY_CORRECTION_INFO: 'Por favor, proporcione una nota para esta corrección de días negativos.',
    DAY_CORRECTION_NOTE_LABEL: 'Nota de Corrección:',
    DAY_CORRECTION_INPUT: 'Nota de Corrección',
    DAY_CORRECTION_INPUT_PLACEHOLDER: 'El huésped solo tomó una carrera',
    DAY_CORRECTION_BUTTON_TITLE: 'Corregir Redención y Cerrar',
  
    DAYS_REDEEM_NO_DAYS: `El huésped no tiene más días para redimir`,
    DAYS_REDEEM_SELECT_TITLE: 'Redimir Días',
    DAYS_REDEEM_REDEEM: 'Redimir...',
    DAYS_REDEEM_BUTTON: 'Redimir',
    DAYS_REDEEM_NUMBER_DAYS: (i) => `${i} Día${i === 1 || i === -1 ? '' : 's'}`,
  
    REDEMPTION_STATS_TOTAL_DAYS: 'Total de Días',
    REDEMPTION_STATS_DAYS_AVAILABLE: 'Días Disponibles',
    REDEMPTION_STATS_DAYS_USED: 'Días Usados',
  
    REDEMPTION_HISTORY_LABEL: '10 Usos Más Recientes:',
    REDEMPTION_HISTORY_DATE: 'Fecha',
    REDEMPTION_HISTORY_RESORT: 'Resort',
    REDEMPTION_HISTORY_REF_ID: 'ID de Ref.',
    REDEMPTION_HISTORY_NO_HISTORY: 'Sin Historial',
  
    REDEMPTION_ID_LABEL: 'ID de Redención:',
    REDEMPTION_ID_TITLE: 'ID de Redención',
    REDEMPTION_ID_BUTTON_TITLE: 'Copiar ID de Redención al Portapapeles',
    REDEMPTION_ID_REFERENCE_LABEL: 'ID de Referencia Local:',
    REDEMPTION_ID_REFERENCE_TITLE: 'Referencia Local',
    REDEMPTION_ID_SAVE_BUTTON_TITLE: 'Guardar Referencia Local y Cerrar',
    REDEMPTION_ID_SAVE_BUTTON: 'Guardar y Cerrar',
  
    // Waivers
    WAIVER_ERROR: 'error',
    WAIVER_UNKNOWN: 'desconocido',
    WAIVER_ALL_FIELDS_REQUIRED: 'Todos los campos son obligatorios.',
    WAIVER_ERROR_OVER_18: 'El huésped debe tener 18 años o más para firmar una exención.',
    WAIVER_UNKNOWN_ERROR: 'Error desconocido al enviar la exención',
    WAIVER_GENERIC_COMMENT: 'Exención reducida de la acción de enviar exención con éxito',
    WAIVER_MODAL_LOADING: 'Cargando...',
    WAIVER_MODAL_ERROR: 'Error - contacte a soporte',
    WAIVER_MODAL_UNKNOWN_TYPE: (version) => `Tipo de Exención Desconocido: ${version}`,
    WAIVER_MODAL_HEADING: 'Exenciones',
    WAIVER_SIGNATURE_COMPLETED_BY: 'Exención Completada Por:',
    WAIVER_SIGNATURE_FIRST_NAME_LABEL: 'Nombre',
    WAIVER_SIGNATURE_FIRST_NAME_TITLE: `Nombre del firmante`,
    WAIVER_SIGNATURE_FIRST_NAME_INPUT: `Ingrese el nombre del firmante`,
    WAIVER_SIGNATURE_LAST_NAME_LABEL: 'Apellido',
    WAIVER_SIGNATURE_LAST_NAME_TITLE: `Apellido del firmante`,
    WAIVER_SIGNATURE_LAST_NAME_INPUT: `Ingrese el apellido del firmante`,
    WAIVER_SIGNATURE_DOB_LABEL: 'Fecha de Nacimiento',
    WAIVER_SIGNATURE_DOB_TITLE: `Fecha de nacimiento del firmante`,
    WAIVER_SIGNATURE_DOB_INPUT: `Ingrese la fecha de nacimiento del firmante`,
    WAIVER_SIGNATURE_CANCEL_TITLE: 'Cancelar la finalización de la exención',
    WAIVER_SIGNATURE_SUBMIT_TITLE: 'Enviar Exención Completada',
    WAIVER_CANCEL: 'Cancelar',
    WAIVER_SUBMIT: 'Enviar',
  
    WAIVER_TABLE_COLUMN_WAIVER: 'Exención',
    WAIVER_TABLE_COLUMN_WAIVER_SIGNED: 'Exención Firmada',
    WAIVER_TABLE_COLUMN_DATE_SIGNED: 'Fecha Firmada',
    WAIVER_TABLE_UNKNOWN: 'Desconocido',
    WAIVER_TABLE_UNSIGNED: 'No Firmado',
    WAIVER_TABLE_EXPIRED: (expirationDate) => ` (Expirado: ${expirationDate})`,
    WAIVER_TABLE_SIGNED: 'Firmado',
    WAIVER_TABLE_NOT_SIGNED: 'No Firmado',
    WAIVER_TABLE_NO_WAIVERS: 'No se encontraron exenciones.',
    WAIVER_TABLE_GUEST_LABEL: 'Huésped:',
    WAIVER_TABLE_CLICK_TO_SIGN: 'Haga clic para firmar',
  
    // Guest card
    GUEST_CARD_DEFERRED_BANNER: 'PASE DIFERIDO',
    GUEST_CARD_HOTLIST_ALL_RESORTS: 'Lista Negra - Todos los Resorts',
    GUEST_CARD_HOTLIST_RESORT: (resortName) => `Lista Negra - ${resortName}`,
    GUEST_CARD_HOTLIST: 'Lista Negra',
    GUEST_CARD_MEDIA_DISABLED: 'MEDIOS DESACTIVADOS',
    GUEST_CARD_COPIED_MASTER_GUEST_ID: '¡ID de Huésped Maestro copiado al portapapeles!',
    GUEST_CARD_COPIED_MEDIA_ID: 'ID de Medios copiado al portapapeles!',
    GUEST_CARD_FAILED_TO_LOAD: 'Error al Cargar',
    GUEST_CARD_OVERFLOW_TOGGLE: 'Alternar Menú Desplegable',
    GUEST_CARD_OVERFLOW_COPY_MGID: 'Copiar ID de Huésped Maestro',
    GUEST_CARD_OVERFLOW_VIEW_DAYS: 'Ver Días',
    GUEST_CARD_OVERFLOW_GUEST_HAS_PASS: `Uso del pase diario del huésped`,
    GUEST_CARD_OVERFLOW_GUEST_NO_PASS: `El huésped no tiene pase para esta temporada`,
    GUEST_CARD_OVERFLOW_MEDIA_HISTORY: 'Historial de Tarjeta de Medios',
    GUEST_CARD_OVERFLOW_MEDIA_HISTORY_TITLE: (guestName) => `Historial de Medios para ${guestName}`,
    GUEST_CARD_OVERFLOW_PUT_HOTLIST: 'Poner a este huésped en la lista negra',
    GUEST_CARD_OVERFLOW_ALREADY_HOTLISTED: 'Todos los pases del huésped ya están en la lista negra',
    GUEST_CARD_OVERFLOW_NO_PASS_HOTLIST: 'El huésped no tiene pase para ser puesto en la lista negra',
    GUEST_CARD_OVERFLOW_HOTLIST: 'Agregar a la Lista Negra',
    GUEST_CARD_OVERFLOW_VIEW_COMMENTS: 'Ver Comentarios',
    GUEST_CARD_OVERFLOW_TAKE_HOTLIST: 'Quitar a este huésped de la lista negra',
    GUEST_CARD_OVERFLOW_REMOVE_HOTLIST: 'Eliminar de la lista negra',
    GUEST_CARD_OVERFLOW_COMMENT_HISTORY: (guestName) => `Historial de Comentarios para ${guestName}`,
    GUEST_CARD_OVERFLOW_ADD_COMMENT: 'Agregar Comentario',
    GUEST_CARD_OVERFLOW_ADD_COMMENT_TITLE: (guestName) => `Agregar un comentario para ${guestName}`,
  
    GUEST_PROFILE_YEARS_OLD: (age) => `${age} años`,
    GUEST_PROFILE_NO_DOB: 'Sin Fecha de Nacimiento',
    GUEST_PROFILE_TOOLTIP: 'Foto del Pase',
    GUEST_PROFILE_DISABLED_TOOLTIP: 'El huésped está en la lista negra.',
  
    PASS_OVERVIEW_NO_MEDIA: 'Sin ID de Medios',
    PASS_OVERVIEW_TITLE: 'ID de Medios de EPIC (igual que el número de código de barras cuando se imprime)',
    PASS_OVERVIEW_COPY_BUTTON: 'Copiar ID de Medios al Portapapeles',
    PASS_OVERVIEW_SEASON: 'Temporada',
    PASS_OVERVIEW_NAME: 'Nombre',
    PASS_OVERVIEW_NO_PASSES: 'No hay Pases Activos',
    PASS_OVERVIEW_NO_ENTITLEMENTS: 'Sin Habilitaciones de Pase',
  
    PRIMARY_ACTIONS_PRINT_CARD: 'Imprimir Tarjeta',
    PRIMARY_ACTIONS_LINK_CARD: 'Vincular Tarjeta RFID',
    PRIMARY_ACTIONS_WAIVER_SIGNED: 'El Huésped ha Firmado la Exención',
    PRIMARY_ACTIONS_WAIVER_SIGNATURE: 'Haga clic para registrar la firma de la exención',
  
    SECONDARY_ACTIONS_REDEEM_PASS: 'Ver y Redimir Pase Diario',
    SECONDARY_ACTIONS_REDEEM_FNF: 'Ver y Redimir Pase de Amigos y Familia',
    SECONDARY_ACTIONS_IMPORT_TOOLTIP: 'Importar Registro de Huéspedes',
  
    // guest comments
    ADD_COMMENT_GUEST_LABEL: 'Huésped:',
    ADD_COMMENT_SUBJECT_LABEL: 'Asunto',
    ADD_COMMENT_COMMENTS_LABEL: 'Comentarios',
    ADD_COMMENT_CHARACTER_INFO: (minChars, maxChars) => `(${minChars} a ${maxChars} caracteres)`,
    ADD_COMMENT_ADD_COMMENT: 'Agregar Comentario',
    ADD_COMMENT_BUTTON_TITLE: (guestName) => `Agregar Comentario para ${guestName}`,
    ADD_COMMENT_ERROR: 'Error inesperado al agregar un nuevo comentario de huésped.',
    COMMENT_HISTORY_COLUMN_DATE: 'Fecha',
    COMMENT_HISTORY_COLUMN_AGENT: 'Agente',
    COMMENT_HISTORY_COLUMN_SUBJECT: 'Asunto',
    COMMENT_HISTORY_COLUMN_COMMENT: 'Comentario',
    COMMENT_HISTORY_NO_HISTORY: 'Este huésped no tiene historial de comentarios.',
    COMMENT_HISTORY_FAILED_FETCH: (guestName) => `Error al recuperar el historial de comentarios de ${guestName}. Inténtelo de nuevo.`,
    COMMENT_NO_SUBJECT: 'Se requiere un asunto.',
    COMMENT_NO_COMMENT: 'Se requiere un comentario de 10 a 500 caracteres.',
    COMMENT_HISTORY_FETCH_ERROR: `Error inesperado al recuperar el historial de comentarios del huésped.`,
    COMMENT_HISTORY_VIEW_COMMENTS: 'Ver Comentarios',
  
    // guest contact
    ADDRESS_NO_ADDRESS_TITLE: `Este huésped no tiene una dirección`,
    ADDRESS_NO_ADDRESS: 'Sin Dirección',
    ADDRESS_NO_DATA: 'Sin Datos',
    ADDRESS_LINE_ONE: 'Línea de Dirección 1',
    ADDRESS_LINE_TWO: 'Línea de Dirección 2',
    ADDRESS_CITY: 'Ciudad',
    ADDRESS_NO_CITY: 'Sin Ciudad, ',
    ADDRESS_STATE: 'Estado',
    ADDRESS_NO_STATE: 'Sin Estado',
    ADDRESS_POSTAL: 'Código Postal',
    ADDRESS_NO_POSTAL: 'Sin Código Postal, ',
    ADDRESS_COUNTRY: 'País',
    ADDRESS_NO_COUNTRY: 'Sin País',
  
    // guest photo
    GUEST_PHOTO_MODAL_HEADING: 'Capturar Foto',
    GUEST_PHOTO_GUEST_LABEL: 'Huésped:',
  
    // hotlist
    HOTLIST_ADD_HOTLIST: 'Agregar a la Lista Negra',
    HOTLIST_PUT_HOTLIST: (guestName) => `Poner a ${guestName} en la lista negra`,
    HOTLIST_NO_ENTITLEMENT: 'Debe seleccionarse un pase para agregarlo a la lista negra.',
    HOTLIST_NO_RESORT: 'Debe seleccionarse un resort.',
    HOTLIST_NO_REASON: 'Se requiere un motivo para agregar a la lista negra.',
    HOTLIST_NO_COMMENT: 'Se requiere un comentario de 10 a 500 caracteres.',
    HOTLIST_INVALID_EFF_DATE: 'Se requiere una fecha de inicio válida para agregar a la lista negra.',
    HOTLIST_INVALID_EXP_DATE: 'Se requiere una fecha de expiración válida para agregar a la lista negra.',
    HOTLIST_PREDATED_EFF_DATE: 'El hotlisting debe hacerse efectivo hoy o en el futuro',
    HOTLIST_EXPIRES_EFF_DATE: 'El hotlisting debe expirar en o después de la fecha de inicio.',
    HOTLIST_MODAL_NO_PASS_SELECTED: 'No se seleccionó ningún pase',
    HOTLIST_MODAL_GUEST_LABEL: 'Huésped:',
    HOTLIST_MODAL_PASS_LABEL: 'Pase',
    HOTLIST_MODAL_PASS_PLACEHOLDER: 'Pase...',
    HOTLIST_MODAL_FAILED_ENTITLEMENTS: 'Error al cargar las habilitaciones',
    HOTLIST_MODAL_RESORT_LABEL: 'Resort',
    HOTLIST_MODAL_REPORTER_CONTACT_NUMBER: 'Número de Contacto del Reportero',
    HOTLIST_COMMENT_WITH_REPORTER_CONTACT: (phoneNumber, comment) => `Número de Contacto del Reportero: ${phoneNumber} - ${comment}`,
    HOTLIST_MODAL_DIRECT_LINE: 'Línea Directa',
    HOTLIST_MODAL_ENTER_PHONE_NUMBER: 'Ingrese el número de teléfono',
    HOTLIST_MODAL_PHONE_EXTENSION: 'Ext.',
    HOTLIST_MODAL_PHONE_NUMBER_REQUIRED: 'El formato del número de teléfono del reportero tiene una extensión pero falta el número de teléfono',
    HOTLIST_MODAL_INVALID_PHONE_NUMBER_FORMAT: 'El formato del número de contacto del reportero es inválido',
    HOTLIST_MODAL_COMMENT_GUIDANCE: 'Incluya una descripción detallada del incidente y los próximos pasos para el seguimiento del huésped...',
    HOTLIST_MODAL_FAILED_TO_LOAD_RESORTS: 'Error al cargar los resorts.',
    HOTLIST_MODAL_RESORT_PLACEHOLDER: 'Resort...',
    HOTLIST_MODAL_FROM_LABEL: 'Desde',
    HOTLIST_MODAL_STARTING_DATE_PLACEHOLDER: 'Fecha de Inicio...',
    HOTLIST_MODAL_STARTING_DATE_TOOLTIP: 'Ingrese la fecha de inicio para el estado de lista negra',
    HOTLIST_MODAL_TO_LABEL: 'Hasta',
    HOTLIST_MODAL_ENDING_DATE_PLACEHOLDER: 'Fecha de Finalización...',
    HOTLIST_MODAL_ENDING_DATE_TOOLTIP: 'Ingrese la fecha de finalización para el estado de lista negra',
    HOTLIST_MODAL_REASON: 'Motivo para la Lista Negra',
    HOTLIST_MODAL_REASON_PLACEHOLDER: 'Motivo...',
    HOTLIST_MODAL_REASON_FAILED: 'Error al cargar los motivos',
    HOTLIST_MODAL_HOTLIST_LABEL: 'Lista Negra:',
    HOTLIST_MODAL_COMMENTS_LABEL: 'Comentarios',
    HOTLIST_MODAL_CANCEL: 'Cancelar',
    HOTLIST_MODAL_CHARACTER_INFO: (minChars, maxChars) => `(${minChars} a ${maxChars} caracteres)`,
    HOTLIST_TABLE_HOTLIST: 'Lista Negra',
    HOTLIST_TABLE_DURATION: 'Duración',
    HOTLIST_TABLE_COMMENT: 'Comentario',
    HOTLIST_TABLE_REMOVE: 'Eliminar de la Lista Negra',
    HOTLIST_TABLE_UNTIL_EXPIRATION: (date) => `Hasta ${date}`,
    HOTLIST_TABLE_INDEFINITE: 'Indefinido',
    HOTLIST_TABLE_GUEST_LABEL: 'Huésped:',
    HOTLIST_TABLE_NO_HOTLIST: 'No hay listas negras activas para este huésped',
    HOTLIST_REMOVE_MODAL_HEADING: 'Eliminar de la Lista Negra',
    HOTLIST_REMOVE_MODAL_SUBMIT_TITLE: (guestName) => `Quitar a ${guestName} de la lista negra`,
    HOTLIST_REMOVE_MODAL_CANCEL_BUTTON: 'Cancelar eliminación de la lista negra',
  
    FEATURE_DISABLING_LOADING_GUEST: 'Cargando huésped...',
    FEATURE_DISABLING_NO_PASS: `El huésped no tiene un pase para esta temporada.`,
    FEATURE_DISABLING_DEFERRED: 'El huésped está usando un pase diferido y no puede redimir habilitaciones en este momento.',
    FEATURE_DISABLING_HOTLISTED: 'El huésped está en la lista negra y no puede redimir habilitaciones en este momento.',
    FEATURE_DISABLING_WAIVER: 'El huésped debe firmar una exención primero',
    FEATURE_DISABLING_NO_FNF: 'El huésped no tiene vales de amigos y familia para este resort.',
    FEATURE_DISABLING_NOT_AVAILABLE: 'Esta función no está disponible en su resort',
    FEATURE_DISABLING_GUEST_IMPORTED: 'El huésped ya está importado.',
  
    GUEST_SNACKBAR_FAILED_PHOTO_LOAD: (guestName) => `Error al cargar la foto de ${guestName}. Inténtelo de nuevo.`,
    GUEST_SNACKBAR_FAILED_PHOTO_SET: (guestName) => `Error al establecer la foto de ${guestName}. Inténtelo de nuevo.`,
    GUEST_SNACKBAR_FAILED_HOTLIST: (guestName) => `Error al cargar los detalles de la lista negra de ${guestName}. Inténtelo de nuevo.`,
    GUEST_SNACKBAR_FAILED_PASSES: (guestName) => `Error al cargar los pases de ${guestName}. Inténtelo de nuevo.`,
    GUEST_SNACKBAR_FAILED_LINK: (guestName) => `Error al vincular el pase de ${guestName}. Inténtelo de nuevo.`,
    GUEST_SNACKBAR_FAILED_SUBMIT_WAIVER: (guestName) => `Error al enviar la exención para ${guestName}. Inténtelo de nuevo.`,
    GUEST_SNACKBAR_FAILED_SUBMIT_REFERENCE: (guestName) => `Error al enviar la referencia local para ${guestName}.`,
    GUEST_SNACKBAR_FAILED_IMPORT: (guestName) => `Error al importar a ${guestName}. Inténtelo de nuevo.`,
    GUEST_SNACKBAR_SUCCESSFUL_IMPORT: (firstName, lastName) => `${firstName} ${lastName} fue importado con éxito.`,  
    GUEST_SNACKBAR_SUCCESSFUL_IMPORT_WITH_ENTITLEMENT_ERROR: (firstName: string, lastName: string, entitlementErrorCount: number) => `${firstName} ${lastName} was successfully imported.\n${entitlementErrorCount} entitlement(s) were not imported.`,

    // Group Search
    GROUP_MENU_GROUP: (NumberInGroup) => `Grupo (${NumberInGroup})`,
    GROUP_MENU_CLOSE_ACTIONS : 'Cerrar Menú de Acciones de Grupo',
    GROUP_MENU_EXPAND_GROUP: 'Expandir el grupo para realizar una acción grupal',
    GROUP_MENU_OPEN_GROUP_ACTIONS: 'Abrir Menú de Acciones de Grupo',
    GROUP_MENU_NO_GUESTS_CAN_BE_PRINTED: 'No hay huéspedes disponibles para imprimir en este momento',
    GROUP_MENU_PRINT_PASSES: 'Imprimir pases para el hogar',
    GROUP_MENU_NO_GUESTS_ELIGIBLE_FOR_IMPORT: 'No hay huéspedes elegibles para importar',
    GROUP_MENU_IMPORT_ALL_HOUSEHOLD: 'Importar todos los miembros elegibles del hogar',
    GROUP_MENU_IMPORTING_GROUP: 'Importando grupo...',
    GROUP_MENU_PRINT_GROUP:  'Imprimir Grupo',
    GROUP_MENU_IMPORT_GROUP: 'Importar Grupo',
  
    HORIZONTAL_GUEST_DETAIL_FIRST_NAME: 'Nombre',
    HORIZONTAL_GUEST_DETAIL_NO_FIRST_NAME: 'Sin Nombre',
    HORIZONTAL_GUEST_DETAIL_LAST_NAME: 'Apellido',
    HORIZONTAL_GUEST_DETAIL_NO_LAST_NAME: 'Sin Apellido',
    HORIZONTAL_GUEST_DETAIL_YEARS_OLD: (Age) => `${Age} años`,
    HORIZONTAL_GUEST_DETAIL_NO_BIRTH_DATE: 'Sin Fecha de Nacimiento',
    HORIZONTAL_GUEST_DETAIL_PRIMARY_EMAIL: 'Correo Electrónico Principal',
    HORIZONTAL_GUEST_DETAIL_NO_EMAIL: 'Sin Correo Electrónico',
    HORIZONTAL_GUEST_DETAIL_PHONE_NUMBER: 'Número de Teléfono Principal',
    HORIZONTAL_GUEST_DETAIL_NO_PHONE_NUMBER: 'Sin Número de Teléfono',
  
    GUEST_SEARCH_RESULT_UNEXPECTED_ERROR: 'Se produjo un error inesperado al cargar el hogar. Inténtelo de nuevo más tarde.',
    GUEST_SEARCH_RESULT_HIDE_GUESTS: 'Ocultar Huéspedes',
    GUEST_SEARCH_RESULT_VIEW_GUESTS: 'Ver Huéspedes',
    GUEST_SEARCH_RESULTS_NO_ACCOUNTS_MATCH: 'No coinciden cuentas ',
    GUEST_SEARCH_RESULTS_PLEASE_SEARCH_AGAIN: ', por favor busque de nuevo.',
    GUEST_SEARCH_BOX_BLACKLISTED: 'Advertencia: Término de búsqueda en lista negra',
    GUEST_SEARCH_MIN_LENGTH: (MinSearchLength) => `Advertencia: Mínimo de ${MinSearchLength} Caracteres para la Búsqueda`,
    GUEST_SEARCH_EPIC_GUEST: 'Buscar un huésped de EPIC',
    GUEST_SEARCH_SEARCH: 'Buscar',
    GUEST_SEARCH_PLACEHOLDER: 'Buscar un Huésped',
    GUEST_SEARCH_TOP_ACCOUNT_MATCH: 'Mejor coincidencia de cuenta para ',
    GUEST_SEARCH_TOP_ACCOUNTS_MATCH: (NumberAccounts) => `Mejores ${NumberAccounts} coincidencias de cuentas para `,
  
    GUEST_SEARCH_SORT_BY: 'Ordenar Por: ',
    GUEST_SORT_MENU_CLOSE: 'Cerrar Menú de Ordenar',
    GUEST_SORT_MENU_OPEN: 'Abrir Menú de Ordenar',
    GUEST_SORT_RELEVANCE: 'Relevancia',
    GUEST_SORT_LAST_NAME_A_Z: 'Apellido (A - Z)',
    GUEST_SORT_LAST_NAME_Z_A: 'Apellido (Z - A)',
    GUEST_SORT_AGE_0_100: 'Edad (0 - 100)',
    GUEST_SORT_AGE_100_0: 'Edad (100 - 0)',
  
    // PassResortSelector
    PASS_RESORT_SELECTOR_NO_PASSES: 'Sin pases',
    PASS_RESORT_SELECTOR_PASSES: 'Pases',
    PASS_RESORT_SELECTOR_NO_RESORTS: 'Sin Resorts',
    PASS_RESORT_SELECTOR_RESORTS: 'Resorts',

    // Reports Page
    REPORTS_TITLE: 'Reports /* TODO */',
    REPORTS_PAGE_INFO: 'Run reports based on Resort Tools activity. /* TODO */',
    REPORTS_GUEST_HYDRATION_ERRORS: 'Guest Hydration Errors /* TODO */',
    REPORTS_GUEST_HYDRATION_ERRORS_MODAL_HEADER: 'Guest Hydration Errors /* TODO */',
    GET_GUEST_HYDRATION_ERRORS_ACTION_ERROR: 'Something went wrong fetching guest hydration errors /* TODO */',
    GUEST_HYDRATION_ERRORS_RETRIED: 'Retried /* TODO */',
    GUEST_HYDRATION_ERRORS_RETRY: 'Retry /* TODO */',
    GUEST_HYDRATION_ERRORS_TOOLTIP: 'Failed hydrations! Please resolve guest errors to retry. /* TODO */',
    GUEST_HYDRATION_REPORT_COPIED_MASTER_GUEST_ID: 'Master Guest ID copied to clipboard /* TODO */',
    GUEST_HYDRATION_REPORT_COPY_MASTER_GUEST_ID: 'Copy Master Guest ID to clipboard /* TODO */',
    GUEST_HYDRATION_REPORT_MGID: 'Master Guest ID /* TODO */',
    GUEST_HYDRATION_REPORT_HYDRATION_ERROR: 'Hydration Error /* TODO */',
    GUEST_HYDRATION_ERRORS_REPLAY_FAILURE: (masterGuestId: string, resortAbbrev: string) => `Unexpected error occurred retrying the guest hydration for ${masterGuestId} at ${resortAbbrev}. Please try again later. /* TODO */`,
    GUEST_HYDRATION_ERRORS_REPLAY_SUCCESS: 'Messages have been sent to the queue for processing /* TODO */',
    GET_GUEST_HYDRATION_ERRORS_COUNT_ACTION_ERROR: 'Something went wrong fetching guest hydration error count /* TODO */',
    GUEST_HYDRATION_ERRORS_GUESTS_PER_PAGE: 'Guests per page: /* TODO */',
    REPORTS_GUEST_HYDRATION_ERRORS_CLOSE: 'Close /* TODO */',
    REPORTS_GUEST_HYDRATION_ERRORS_CLOSE_TITLE: 'Close Guest Hydration Errors Report /* TODO */',
    REPORTS_GUEST_HYDRATION_ERRORS_NO_ERRORS_TOOLTIP: 'No Guest Hydration Errors found! /* TODO */',
    REPORTS_HOTLIST_REASON: 'Reason for Hotlist /* TODO */',
    REPORTS_HOTLIST_REASON_PLACEHOLDER: 'Reason... /* TODO */',
    REPORTS_HOTLIST_REASON_FAILED: 'Failed to load reasons /* TODO */',
    REPORTS_HOTLIST_FROM_LABEL: 'From /* TODO */',
    REPORTS_HOTLIST_FROM_DATE_TOOLTIP: 'Enter the From date for the hotlist report /* TODO */',
    REPORTS_HOTLIST_TO_LABEL: 'To /* TODO */',
    REPORTS_HOTLIST_TO_DATE_TOOLTIP: 'Enter the To date for the hotlist report /* TODO */',
    REPORTS_HOTLIST_NO_REASON: 'A reason is required for the hotlist report. /* TODO */',
    REPORTS_HOTLIST_INVALID_FROM_DATE: 'A valid From date is required for the hotlist report. /* TODO */',
    REPORTS_HOTLIST_INVALID_TO_DATE: 'A valid To date is required for the hotlist report. /* TODO */',
    REPORTS_HOTLIST_FROM_BEFORE_TO_DATE: 'To date must be on or after From date. /* TODO */',
    REPORTS_HOTLIST_DATE_RANGE_MAX: 'Date range too large. The maximum date range for the hotlist report is 1 year. /* TODO */',
    REPORTS_HOTLIST_ERROR_GENERATING_CSV_FILE: 'Something went wrong generating the csv file. /* TODO */',
    REPORTS_HOTLIST_ERROR_DOWNLOAD_FAILED: 'Failed to download hotlist report. /* TODO */',
    REPORTS_HOTLIST_CREATED_DATE: 'Created Date /* TODO */',
    REPORTS_HOTLIST_NARROW_SEARCH_PARAMS: 'Too much data. Please narrow your search parameters. /* TODO */',
    REPORTS_HOTLIST_ERROR_NO_DATA: 'No hotlist data found for the current search parameters. /* TODO */',
    REPORTS_HOTLIST_REQUEST_CANCELLED: 'Request was canceled. Please try again. /* TODO */',
    REPORTS_HOTLIST_INVALID_PARAMETERS: 'Invalid request parameters. /* TODO */',
    REPORTS_WEEKLY_VISTOR_DATA: 'Weekly Visitor Data /* TODO */',
    REPORTS_CLOSE: 'Close /* TODO */',
    REPORTS_WEEKLY_VISITOR_DATA_CLOSE_TITLE: 'Close Weekly Visitor Data Reports /* TODO */',
    REPORTS_WEEKLY_VISITOR_ERROR_LOADING: 'Failed to load Weekly Visitor Data Reports /* TODO */',
    REPORTS_DOWNLOADING: 'Downloading... /* TODO */',
  };
  
  export default es_es;
  